import { checkActionsType } from '@src/middlewares/utils';
import loadScript from '@utils/loadScript';
import { EnvsEnum } from '@utils/types';

import { userActions } from '@modules';
import globalActions from '@modules/global/actions';
import { TMiddleware } from '@modules/types';

import ForethoughtConstants from './constants';

const {
  FORETHOUGHT_API_KEY,
  FORETHOUGHT_SCRIPT_ID,
  FORETHOUGHT_SCRIPT_URL,
  FORETHOUGHT_CONFIG,
  FORETHOUGHT_WORKFLOW_TAGS,
  FORETHOUGHT_EVENTS,
  FORETHOUGHT_TOKEN_CV_UUID,
} = ForethoughtConstants;

const forethought: TMiddleware = () => next => action => {
  if (checkActionsType(action, [globalActions.appStarted])) {
    const setForethoughtState = (isLoading: boolean, isError?: boolean) => {
      const event = new CustomEvent(FORETHOUGHT_EVENTS.stateChanged, {
        detail: { isLoading, isError },
      });
      window.dispatchEvent(event);
    };

    setForethoughtState(true);

    const workflowTag =
      CONST.env !== EnvsEnum.prod
        ? FORETHOUGHT_WORKFLOW_TAGS.development
        : FORETHOUGHT_WORKFLOW_TAGS.production;

    const forethoughtAttributes = {
      'data-api-key': FORETHOUGHT_API_KEY,
      'data-ft-workflow-tag': workflowTag,
      ...FORETHOUGHT_CONFIG,
    };

    loadScript(FORETHOUGHT_SCRIPT_URL, FORETHOUGHT_SCRIPT_ID, forethoughtAttributes).catch(
      error => {
        console.error('Error initializing Forethought script:', error);
        setForethoughtState(false, true);
        window?.zE('messenger', 'show');
      }
    );
  } else if (checkActionsType(action, [userActions.zendeskVerification.fulfilled])) {
    const forethoughtScript = document.getElementById(FORETHOUGHT_SCRIPT_ID);
    forethoughtScript?.setAttribute('data-ft-zendesk-token', action.payload.data.token);

    if (window?.Forethought && typeof window.Forethought === 'function') {
      window.Forethought('widget', 'updateConversationContext', {
        [FORETHOUGHT_TOKEN_CV_UUID]: action.payload.data.token,
      });
    }
  }
  return next(action);
};

export default forethought;
